import api from './api';
import isMobileApp from '@/utils/isMobileApp'
import { getEventContext } from '../utils/eventContext';
import sendWebViewMessage from '../utils/sendWebViewMessage';
import getUrlParameter from "../utils/getUrlParameter";

const defaultSource = takeSource()

export function createDocumentView({ resource_id, source }) {
    const { eventId } = getEventContext()

    return createView({
        resource_id,
        source,
        resource_type: 'file',
        event_id: eventId,
    });
}

export function createVideoView({ resource_id, video_type, source }) {
    const { eventId } = getEventContext()

    if (isMobileApp()) {
        sendWebViewMessage({
            message_type: 'video_view',
            resource_id,
            video_type,
        })
    } else {
        createView({
            resource_id,
            video_type,
            source: getSource(source),
            resource_type: 'video',
            event_id: eventId,
        })
    }
}

async function getMetadata() {
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform
    }
}

export async function createProfileView({ resource_id, source }) {
    const { eventId } = getEventContext()

    const { viewId } = await createView({
        resource_id,
        source: getSource(source),
        resource_type: 'profile',
        event_id: eventId,
        metadata: await getMetadata()
    })

    sessionStorage.setItem('lastProfileViewId', viewId)
}

function getSource(source)
{
    if(isMobileApp()) {
        return 'eventbeacon';
    }

    return source || getUrlSource() || defaultSource;
}

/**
 * Reads the `source` query parameter off the current URL.
 *
 * getUrlParameter() decodes the whole query string with decodeURIComponent(),
 * which throws a URIError on a malformed percent-escape (e.g. `?source=%`).
 * A malformed URL must never break view tracking, so failures degrade to null
 * and let the caller fall through to the next source in the chain.
 */
export function getUrlSource()
{
    try {
        return getUrlParameter('source');
    } catch (e) {
        return null;
    }
}

async function createView(detail = {}) {
    detail.referrer = document.referrer;
    detail.source = detail.source ? detail.source : defaultSource
    detail.location = window.location.href;
    detail.metadata = detail.metadata ? detail.metadata : null;

    const { viewId } = await api.post("/api/v1/view", detail);
    return { viewId }
}

export function saveViewSource(source) {
    localStorage.setItem('view_source', source)
}

function takeSource() {
    if (!window.view_source) {
        window.view_source = localStorage.getItem('view_source')
        localStorage.removeItem('view_source')
    }

    return window.view_source
}